import { Box, IconButton, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Status } from "../../../client/status";
import { useMenuData } from "../../../menu-provider/MenuDataProvider";
import { useAddCategoryClient } from "./addCategoryClient";
import { alertOptions } from "./alertOptions";
import AddIcon from "@mui/icons-material/Add";

const isEmptyOrSpacesOnly = (categoryName: string) => {
  return !categoryName.replace(/\s/g, "").length;
};

export const AddCategory = () => {
  const [categoryName, setCategoryName] = useState<string>("");
  const { status, saveNewCategory } = useAddCategoryClient();
  const { reloadMenuData } = useMenuData();
  const alert = useAlert();

  const addNewCategory = () => {
    if (isEmptyOrSpacesOnly(categoryName)) return;
    saveNewCategory({ categoryName: categoryName });
  };

  useEffect(() => {
    if (status == Status.Success) {
      alert.success("Category added successfully!", alertOptions);
      reloadMenuData();
      setCategoryName("");
      return;
    }

    status == Status.Error && alert.error("Request failed!", alertOptions);
  }, [status, alert, reloadMenuData]);

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <TextField
        variant="outlined"
        size="small"
        placeholder="Category name"
        value={categoryName}
        onChange={(event) => setCategoryName(event.target.value)}
        onKeyDown={(e) => e.key === "Enter" && addNewCategory()}
        fullWidth
        sx={{ "& .MuiOutlinedInput-root": { fontSize: 13 } }}
      />
      <IconButton
        data-testid="test-id-add-category-button"
        color="primary"
        onClick={addNewCategory}
        disabled={isEmptyOrSpacesOnly(categoryName)}
        size="small"
        sx={{
          bgcolor: isEmptyOrSpacesOnly(categoryName)
            ? undefined
            : "primary.main",
          color: isEmptyOrSpacesOnly(categoryName) ? undefined : "white",
          borderRadius: 1,
          "&:hover": { bgcolor: "primary.dark", color: "white" },
          "&.Mui-disabled": { bgcolor: "transparent" },
          flexShrink: 0,
        }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
